// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   api:'http://inspectmite.net/api/',
//   apiSite:'http://inspectmite.net/',
//   oldSite:'http://twinhouse.net/',
//   doSpace:'https://twininspection-development.nyc3.digitaloceanspaces.com',
// };


	const parsedUrl = new URL(window.location.href);
	const baseUrl = parsedUrl.host;
  
  	var constArray = {
    	production: true,
    	api:'https://live.twininspections.com/api/',
    	apiSite:'https://live.twininspections.com/',
    	oldSite:'https://twininspections.com/',
    	doSpace:'https://twin-inspections-media.nyc3.digitaloceanspaces.com',
	appDashboard:'ISM',
	  inspectionReports : true	
	};
  	if(baseUrl == 'app.finley.inspectmite.com') {
    		constArray = {
      		production: true,
      		api:'https://app.finley.inspectmite.com/api/',
    		apiSite:'https://app.finley.inspectmite.com/',
    		oldSite:'https://finley.inspectmite.com/',
      		doSpace:'https://finley-media.nyc3.digitaloceanspaces.com',
		appDashboard:'Finley',
inspectionReports : true
		};
  	}
if(baseUrl == 'app.pinnacle.inspectmite.com') {
                constArray = {
                production: true,
                api:'https://app.pinnacle.inspectmite.com/api/',
                apiSite:'https://app.pinnacle.inspectmite.com/',
                oldSite:'https://pinnacle.inspectmite.com/',
                doSpace:'https://pinnacle-media.nyc3.digitaloceanspaces.com',
                appDashboard:'Pinnacle',
inspectionReports : true
                };
        }
if(baseUrl == 'app.thrasher.inspectmite.com') {
    constArray = {
	    production: true,
	    api:'https://app.thrasher.inspectmite.com/api/',
	    apiSite:'https://app.thrasher.inspectmite.com/',
	    oldSite:'https://thrasher.inspectmite.com/',
	    doSpace:'https://thrasher-media.nyc3.digitaloceanspaces.com',
	    appDashboard:'Thrasher',
		inspectionReports : true
    };
}
        if(baseUrl == 'app.xtermite.inspectmite.com') {
                constArray = {
                production: true,
                api:'https://app.xtermite.inspectmite.com/api/',
                apiSite:'https://app.xtermite.inspectmite.com/',
                oldSite:'https://xtermite.inspectmite.com/',
                doSpace:'https://xtermite-media.nyc3.digitaloceanspaces.com',
                appDashboard:'XTERMITE',
inspectionReports : true
                };
        }
if(baseUrl == 'app.neighborly.inspectmite.com') {
    constArray = {
    production: true,
    api:'https://app.neighborly.inspectmite.com/api/',
    apiSite:'https://app.neighborly.inspectmite.com/',
    oldSite:'https://neighborly.inspectmite.com/',
    doSpace:'https://neighborly-media.nyc3.digitaloceanspaces.com',
    appDashboard:'NEIGHBORLY',
    inspectionReports : true
};
}
if(baseUrl == 'app.buenavista.inspectmite.com') {
    constArray = {
    production: true,
    api:'https://app.buenavista.inspectmite.com/api/',
    apiSite:'https://app.buenavista.inspectmite.com/',
    oldSite:'https://buenavista.inspectmite.com/',
    doSpace:'https://buenavista-media.nyc3.digitaloceanspaces.com',
    appDashboard:'BUENAVISTA',
    inspectionReports : true
};
}
  	export const environment = constArray;


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
